// import React, { useState, useMemo } from "react";
// import toast from "react-hot-toast";
// import { useAuth } from "../context/AuthContext";
// import {
//   getRowMonthKey, monthKeyLabel,
//   Field, ItemsTable, DiscountsTable,
//   EditModal, DetailPanel, ConfirmModal,
//   exportSingleInvoice, exportSellerInvoices, deleteInvoices,
// } from "./invoiceShared";

// // ── Invoice Card ───────────────────────────────────────────────────────────────

// function InvoiceCard({ row, selected, onToggle, onView, onDelete, onEdit, onExport, canEdit, canDelete, canExport, featured }) {
//   const [showItems, setShowItems] = useState(false);
//   const f = v => (v != null && v !== "" ? String(v) : null);
//   const itemCount = row.items?.length ?? 0;

//   return (
//     <div className={`invoice-card ${selected ? "card-selected" : ""} ${featured ? "card-featured" : ""}`}>
//       {featured && <div className="card-featured-badge">🆕 Recently Scanned</div>}
//       <div className="card-top">
//         <input type="checkbox" className="card-checkbox" checked={selected} onChange={onToggle} />
//         <div className="card-inv-info">
//           <div className="card-inv-no">{f(row.invoice_no) || "No Invoice No."}</div>
//           <div className="card-date">{f(row.invoice_date) || f(row.created_at?.slice(0, 10)) || ""}</div>
//         </div>
//         {f(row.total_inr_figures) && (
//           <div className="card-total">
//             <div className="card-total-amt">₹ {row.total_inr_figures}</div>
//           </div>
//         )}
//       </div>

//       <hr className="card-divider" />

//       <div className="card-fields">
//         <Field label="Seller"          value={f(row.seller_name)} />
//         <Field label="Buyer"           value={f(row.buyer_name)} />
//         <Field label="Seller GST"      value={f(row.seller_gst)} warning={row.seller_gst_unverified ? "GSTIN unverified - likely misread, please verify" : null} />
//         <Field label="Buyer GST"       value={f(row.buyer_gst)} warning={row.buyer_gst_unverified ? "GSTIN unverified - likely misread, please verify" : null} />
//         <Field label="Consignee"       value={f(row.consignee_name)} />
//         <Field label="Place of Supply" value={f(row.place_of_supply)} />
//         {f(row.contract_no) && (
//           <Field label="Contract No." value={`${row.contract_no}${row.contract_date ? " / " + row.contract_date : ""}`} />
//         )}
//         {f(row.delivery_order_no) && <Field label="DO No." value={f(row.delivery_order_no)} />}
//         {f(row.buyer_order_no) && (
//           <Field label="Buyer Order" value={`${row.buyer_order_no}${row.buyer_order_date ? " / " + row.buyer_order_date : ""}`} />
//         )}
//         {f(row.vehicle_no) && <Field label="Vehicle No." value={f(row.vehicle_no)} />}
//         {f(row.dc_no)      && <Field label="DC No."      value={f(row.dc_no)} />}
//         {f(row.rr_lr_no)   && <Field label="RR / LR No." value={f(row.rr_lr_no)} />}
//         {f(row.e_way_bill_no) && <Field label="E-Way Bill" value={f(row.e_way_bill_no)} />}
//         {f(row.irn_no)     && <Field label="IRN No."     value={f(row.irn_no)} />}
//         {f(row.terms_of_payment) && <Field label="Payment Terms" value={f(row.terms_of_payment)} />}
//       </div>

//       {/* Line items toggle */}
//       {itemCount > 0 && (
//         <button
//           onClick={() => setShowItems(s => !s)}
//           style={{
//             width: "100%", padding: "6px 10px", marginTop: 8,
//             background: showItems ? "rgba(92,78,232,.07)" : "var(--surface2)",
//             border: "1px solid var(--border)", borderRadius: 7,
//             fontSize: 12, color: "var(--accent2)", fontWeight: 600, cursor: "pointer",
//             display: "flex", alignItems: "center", justifyContent: "space-between",
//           }}
//         >
//           <span>📦 {itemCount} line item{itemCount !== 1 ? "s" : ""}</span>
//           <span style={{ fontSize: 10 }}>{showItems ? "▲ hide" : "▼ show"}</span>
//         </button>
//       )}
//       {showItems && <ItemsTable items={row.items} discountPercent={row.discount_percent} invoiceDate={row.invoice_date} />}
//       {showItems && <DiscountsTable discountsJson={row.discounts_json} />}

//       {f(row.amount_words) && (
//         <div className="card-words" style={{ marginTop: 10 }}>
//           <span className="card-field-label">In Words: </span>
//           <span>{row.amount_words}</span>
//         </div>
//       )}

//       <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 8 }}>
//         Uploaded by <strong>{row.uploaded_by || "—"}</strong>
//         {row.uploaded_time_ist ? ` · ${row.uploaded_time_ist.slice(0, 16).replace("T", " ")}` : ""}
//       </div>

//       <div className="card-actions" style={{ marginTop: 12 }}>
//         <button className="btn-tiny" onClick={onView} title="View all details">👁 View Details</button>
//         {canExport && (
//           <button
//             className="btn-tiny btn-tiny-export"
//             onClick={onExport}
//             title="Export this invoice as CSV"
//           >
//             ⬇ Export CSV
//           </button>
//         )}
//         {canEdit && (
//           <button
//             className="btn-tiny"
//             style={{ color: "var(--accent2)", borderColor: "rgba(92,78,232,.3)" }}
//             onClick={onEdit}
//           >
//             ✏ Edit
//           </button>
//         )}
//         {canDelete && (
//           <button
//             className="btn-tiny"
//             style={{ color: "var(--err)", borderColor: "rgba(220,38,38,.3)" }}
//             onClick={onDelete}
//           >
//             🗑 Delete
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

// export default function InvoiceGrid({ rows, onDeleted, onUpdated, limit, grouped = true }) {
//   const { hasPermission } = useAuth();
//   const [search,    setSearch]    = useState("");
//   const [selected,  setSelected]  = useState(new Set());
//   const [detailRow, setDetailRow] = useState(null);
//   const [editRow,   setEditRow]   = useState(null);
//   const [sortKey,   setSortKey]   = useState("created_at");
//   const [sortDir,   setSortDir]   = useState("desc");
//   const [selectedMonth, setSelectedMonth] = useState("all");
//   const [confirmDelete, setConfirmDelete] = useState(null); 
//   const canEdit   = hasPermission("edit_invoice");
//   const canDelete = hasPermission("delete_invoice");
//   const canExport = hasPermission("export_csv");

//   const monthOptions = useMemo(() => {
//     const counts = new Map();
//     let unknownCount = 0;
//     rows.forEach(r => {
//       const key = getRowMonthKey(r);
//       if (!key) { unknownCount++; return; }
//       counts.set(key, (counts.get(key) || 0) + 1);
//     });
//     const opts = [...counts.entries()]
//       .sort((a, b) => b[0].localeCompare(a[0]))
//       .map(([key, count]) => ({ key, label: monthKeyLabel(key), count }));
//     if (unknownCount) opts.push({ key: "unknown", label: "No Date", count: unknownCount });
//     return opts;
//   }, [rows]);

//   const monthFiltered = useMemo(() => {
//     if (selectedMonth === "all") return rows;
//     if (selectedMonth === "unknown") return rows.filter(r => !getRowMonthKey(r));
//     return rows.filter(r => getRowMonthKey(r) === selectedMonth);
//   }, [rows, selectedMonth]);

//   const filtered = useMemo(() => {
//     const q = search.toLowerCase();
//     return monthFiltered.filter(r => {
//       if (!q) return true;
//       const headerMatch = Object.entries(r).some(([k, v]) =>
//         k !== "items" && String(v ?? "").toLowerCase().includes(q)
//       );
//       const itemMatch = r.items?.some(item =>
//         Object.values(item).some(v => String(v ?? "").toLowerCase().includes(q))
//       );
//       return headerMatch || itemMatch;
//     });
//   }, [monthFiltered, search]);

//   const sorted = useMemo(() => {
//     return [...filtered].sort((a, b) => {
//       const av = String(a[sortKey] ?? "");
//       const bv = String(b[sortKey] ?? "");
//       return sortDir === "asc" ? av.localeCompare(bv) : bv.localeCompare(av);
//     });
//   }, [filtered, sortKey, sortDir]);

//   const visible = useMemo(() => {
//     if (!limit) return sorted;
//     return sorted.slice(0, limit);
//   }, [sorted, limit]);

//   const sellerGroups = useMemo(() => {
//     if (!grouped) return null;
//     const map = new Map();
//     for (const row of visible) {
//       const key = row.seller_name?.trim() || "Unknown Seller";
//       if (!map.has(key)) map.set(key, []);
//       map.get(key).push(row);
//     }
//     return [...map.entries()];
//   }, [visible, grouped]);

//   const toggleSelect = id =>
//     setSelected(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

//   const toggleAll = e =>
//     setSelected(e.target.checked ? new Set(visible.map(r => r.id)) : new Set());

//   const toggleSellerGroup = groupRows =>
//     setSelected(prev => {
//       const ids  = groupRows.map(r => r.id);
//       const n    = new Set(prev);
//       const allOn = ids.every(id => n.has(id));
//       ids.forEach(id => allOn ? n.delete(id) : n.add(id));
//       return n;
//     });

//   const deleteSingle = id => setConfirmDelete({ ids: [id] });

//   const deleteSelected = () => {
//     if (!selected.size) return;
//     setConfirmDelete({ ids: [...selected] });
//   };

//   const runDelete = async () => {
//     if (!confirmDelete) return;
//     const { ids } = confirmDelete;
//     try {
//       await deleteInvoices(ids);
//       toast.success(ids.length > 1 ? `${ids.length} record(s) deleted` : "Record deleted");
//       onDeleted(ids);
//       setSelected(prev => {
//         const n = new Set(prev);
//         ids.forEach(id => n.delete(id));
//         return n;
//       });
//     } catch {
//       toast.error("Delete failed");
//     } finally {
//       setConfirmDelete(null);
//     }
//   };

//   const renderCard = (row, featured = false) => (
//     <InvoiceCard
//       key={row.id}
//       row={row}
//       selected={selected.has(row.id)}
//       onToggle={() => toggleSelect(row.id)}
//       onView={() => setDetailRow(row)}
//       onEdit={() => setEditRow(row)}
//       onDelete={() => deleteSingle(row.id)}
//       onExport={() => exportSingleInvoice(row)}
//       canEdit={canEdit}
//       canDelete={canDelete}
//       canExport={canExport}
//       featured={featured}
//     />
//   );

//   return (
//     <div className="grid-split">
//     <div className="grid-wrap">
//       {/* Toolbar */}
//       <div className="grid-toolbar">
//         <input
//           className="grid-search"
//           placeholder="🔍  Search across all fields & items…"
//           value={search}
//           onChange={e => setSearch(e.target.value)}
//         />
//         <select
//           className="month-picker"
//           value={selectedMonth}
//           onChange={e => setSelectedMonth(e.target.value)}
//         >
//           <option value="all">📅 All Months</option>
//           {monthOptions.map(o => (
//             <option key={o.key} value={o.key}>{o.label} ({o.count})</option>
//           ))}
//         </select>
//         <div className="grid-actions">
//           <span className="grid-count">
//             {limit && sorted.length > limit
//               ? `Showing ${visible.length} of ${sorted.length}`
//               : `${visible.length} record${visible.length !== 1 ? "s" : ""}`}
//           </span>
//           {selected.size > 0 && (
//             <button className="btn-danger" onClick={deleteSelected}>
//               🗑 Delete {selected.size} selected
//             </button>
//           )}
//           {visible.length > 0 && (
//             <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "var(--text2)", cursor: "pointer" }}>
//               <input
//                 type="checkbox"
//                 style={{ accentColor: "var(--accent2)" }}
//                 checked={selected.size === visible.length && visible.length > 0}
//                 onChange={toggleAll}
//               />
//               Select all
//             </label>
//           )}
//         </div>
//       </div>

//       {visible.length === 0 ? (
//         <div className="empty-state">
//           <span style={{ fontSize: 40 }}>📄</span>
//           <p>
//             {search
//               ? "No invoices match your search."
//               : selectedMonth !== "all"
//                 ? "No invoices found for this month."
//                 : "No invoices found. Upload some PDFs to get started."}
//           </p>
//         </div>
//       ) : grouped ? (
//         sellerGroups.map(([sellerName, groupRows]) => (
//           <div key={sellerName} className="seller-section">
//             <div className="seller-header">
//               <div className="seller-title">
//                 <input
//                   type="checkbox"
//                   style={{ accentColor: "var(--accent2)", width: 15, height: 15, cursor: "pointer" }}
//                   checked={groupRows.every(r => selected.has(r.id))}
//                   onChange={() => toggleSellerGroup(groupRows)}
//                 />
//                 <span className="seller-name-label">🏭 {sellerName}</span>
//                 <span className="seller-count">{groupRows.length} invoice{groupRows.length !== 1 ? "s" : ""}</span>
//               </div>
//               {canExport && (
//                 <button
//                   className="btn-seller-export"
//                   onClick={() => exportSellerInvoices(sellerName, groupRows)}
//                   title={`Export all ${sellerName} invoices as one CSV`}
//                 >
//                   ⬇ Export All CSV
//                 </button>
//               )}
//             </div>

//             <div className="invoice-cards-grid">
//               {groupRows.map(row => renderCard(row))}
//             </div>
//           </div>
//         ))
//       ) : (
//         <>
//           {visible.length > 0 && (
//             <div className="invoice-cards-featured">
//               {renderCard(visible[0], true)}
//             </div>
//           )}
//           <div className="invoice-cards-grid">
//             {visible.slice(1).map(row => renderCard(row))}
//           </div>
//         </>
//       )}
//     </div>

//     {detailRow && <DetailPanel row={detailRow} onClose={() => setDetailRow(null)} />}

//       {editRow && (
//         <EditModal
//           row={editRow}
//           onClose={() => setEditRow(null)}
//           onSaved={updated => { onUpdated && onUpdated(updated); setEditRow(null); }}
//         />
//       )}

//       {confirmDelete && (
//         <ConfirmModal
//           title="Delete record"
//           message={
//             confirmDelete.ids.length > 1
//               ? `Are you sure you want to delete ${confirmDelete.ids.length} records? This cannot be undone.`
//               : "Are you sure you want to delete this record? This cannot be undone."
//           }
//           onConfirm={runDelete}
//           onCancel={() => setConfirmDelete(null)}
//         />
//       )}
//     </div>
//   );
// }


















import React, { useState, useMemo } from "react";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import {
  getRowMonthKey, monthKeyLabel,
  Field, ItemsTable, DiscountsTable,
  EditModal, DetailPanel, ConfirmModal,
  exportSingleInvoice, exportSellerInvoices, deleteInvoices,
  resolveVendorMatch, postInvoiceToErp,
} from "./invoiceShared";

// ── Invoice Card ───────────────────────────────────────────────────────────────

function InvoiceCard({ row, selected, onToggle, onView, onDelete, onEdit, onExport, onVendorResolve, onPost, posting, canEdit, canDelete, canExport, featured }) {
  const [showItems, setShowItems] = useState(false);
  const [showVendorConfirm, setShowVendorConfirm] = useState(false);
  const f = v => (v != null && v !== "" ? String(v) : null);
  const itemCount = row.items?.length ?? 0;

  return (
    <div className={`invoice-card ${selected ? "card-selected" : ""} ${featured ? "card-featured" : ""}`}>
      {featured && <div className="card-featured-badge">🆕 Recently Scanned</div>}
      <div className="card-top">
        <input type="checkbox" className="card-checkbox" checked={selected} onChange={onToggle} />
        <div className="card-inv-info">
          <div className="card-inv-no">{f(row.invoice_no) || "No Invoice No."}</div>
          <div className="card-date">{f(row.invoice_date) || f(row.created_at?.slice(0, 10)) || ""}</div>
        </div>
        {f(row.total_inr_figures) && (
          <div className="card-total">
            <div className="card-total-amt">₹ {row.total_inr_figures}</div>
          </div>
        )}
      </div>

      {row.vendor_verify_status && (
        <div style={{ marginTop: 8, marginBottom: -4 }}>
          {row.vendor_verify_status === "verified" && (
            <span style={{
              fontSize: 12, fontWeight: 600, color: "var(--ok, #a6e3a1)",
              display: "inline-flex", alignItems: "center", gap: 5,
            }} title={`Reported vendor "${row.vendor_reported_name || ""}" matches extracted vendor`}>
              ✅ Vendor Verified
            </span>
          )}
          {row.vendor_verify_status === "mismatch_pending" && (
            <button
              className="btn-tiny"
              style={{ color: "var(--err)", borderColor: "rgba(220,38,38,.3)" }}
              onClick={() => setShowVendorConfirm(true)}
              title={`Reported vendor "${row.vendor_reported_name || "—"}" doesn't match extracted vendor "${row.seller_name || "—"}"`}
            >
              ⚠ Vendor Mismatch-Review
            </button>
          )}
          {row.vendor_verify_status === "mismatch_confirmed" && (
            <span style={{ fontSize: 12, color: "var(--accent2)", fontWeight: 600 }}>
              ⚠ Vendor mismatch-proceeded manually
            </span>
          )}
          {row.vendor_verify_status === "mismatch_rejected" && (
            <span style={{ fontSize: 12, color: "var(--err)", fontWeight: 600 }}>
              ⛔ Vendor mismatch-stopped
            </span>
          )}
        </div>
      )}

      {showVendorConfirm && (
        <ConfirmModal
          title="Vendor name mismatch"
          message={`The vendor name reported by the ERP system ("${row.vendor_reported_name || "—"}") doesn't match the extracted vendor ("${row.seller_name || "—"}"). Do you want to proceed anyway?`}
          confirmLabel="Yes, Proceed"
          cancelLabel="No, Stop"
          danger={false}
          onConfirm={() => { onVendorResolve && onVendorResolve(row.id, true); setShowVendorConfirm(false); }}
          onCancel={() => { onVendorResolve && onVendorResolve(row.id, false); setShowVendorConfirm(false); }}
        />
      )}

      <hr className="card-divider" />

      <div className="card-fields">
        <Field label="Seller"          value={f(row.seller_name)} />
        <Field label="Buyer"           value={f(row.buyer_name)} />
        <Field label="Seller GST"      value={f(row.seller_gst)} warning={row.seller_gst_unverified ? "GSTIN unverified - likely misread, please verify" : null} />
        <Field label="Buyer GST"       value={f(row.buyer_gst)} warning={row.buyer_gst_unverified ? "GSTIN unverified - likely misread, please verify" : null} />
        <Field label="Consignee"       value={f(row.consignee_name)} />
        <Field label="Place of Supply" value={f(row.place_of_supply)} />
        {f(row.contract_no) && (
          <Field label="Contract No." value={`${row.contract_no}${row.contract_date ? " / " + row.contract_date : ""}`} />
        )}
        {f(row.delivery_order_no) && <Field label="DO No." value={f(row.delivery_order_no)} />}
        {f(row.buyer_order_no) && (
          <Field label="Buyer Order" value={`${row.buyer_order_no}${row.buyer_order_date ? " / " + row.buyer_order_date : ""}`} />
        )}
        {f(row.vehicle_no) && <Field label="Vehicle No." value={f(row.vehicle_no)} />}
        {f(row.dc_no)      && <Field label="DC No."      value={f(row.dc_no)} />}
        {f(row.rr_lr_no)   && <Field label="RR / LR No." value={f(row.rr_lr_no)} />}
        {f(row.e_way_bill_no) && <Field label="E-Way Bill" value={f(row.e_way_bill_no)} />}
        {f(row.irn_no)     && <Field label="IRN No."     value={f(row.irn_no)} />}
        {f(row.terms_of_payment) && <Field label="Payment Terms" value={f(row.terms_of_payment)} />}
      </div>

      {/* Line items toggle */}
      {itemCount > 0 && (
        <button
          onClick={() => setShowItems(s => !s)}
          style={{
            width: "100%", padding: "6px 10px", marginTop: 8,
            background: showItems ? "rgba(92,78,232,.07)" : "var(--surface2)",
            border: "1px solid var(--border)", borderRadius: 7,
            fontSize: 12, color: "var(--accent2)", fontWeight: 600, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}
        >
          <span>📦 {itemCount} line item{itemCount !== 1 ? "s" : ""}</span>
          <span style={{ fontSize: 10 }}>{showItems ? "▲ hide" : "▼ show"}</span>
        </button>
      )}
      {showItems && <ItemsTable items={row.items} discountPercent={row.discount_percent} invoiceDate={row.invoice_date} />}
      {showItems && <DiscountsTable discountsJson={row.discounts_json} />}

      {f(row.amount_words) && (
        <div className="card-words" style={{ marginTop: 10 }}>
          <span className="card-field-label">In Words: </span>
          <span>{row.amount_words}</span>
        </div>
      )}

      <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 8 }}>
        Uploaded by <strong>{row.uploaded_by || "—"}</strong>
        {row.uploaded_time_ist ? ` · ${row.uploaded_time_ist.slice(0, 16).replace("T", " ")}` : ""}
      </div>

      <div className="card-actions" style={{ marginTop: 12 }}>
        <button className="btn-tiny" onClick={onView} title="View all details">👁 View Details</button>
        {canExport && (
          <button
            className="btn-tiny btn-tiny-export"
            onClick={onExport}
            title="Export this invoice as CSV"
          >
            ⬇ Export CSV
          </button>
        )}
        {canEdit && (
          <button
            className="btn-tiny"
            style={{ color: "var(--accent2)", borderColor: "rgba(92,78,232,.3)" }}
            onClick={onEdit}
          >
            ✏ Edit
          </button>
        )}
        {canDelete && (
          <button
            className="btn-tiny"
            style={{ color: "var(--err)", borderColor: "rgba(220,38,38,.3)" }}
            onClick={onDelete}
          >
            🗑 Delete
          </button>
        )}
        {row.erp_posted ? (
                  <span className="btn-tiny" style={{ color: "var(--ok, #a6e3a1)", borderColor: "rgba(166,227,161,.35)", cursor: "default" }}>
                    ✅ Posted to ERP
                  </span>
                ) : (row.vendor_verify_status !== "mismatch_pending" && row.vendor_verify_status !== "mismatch_rejected") && (
                  <button
                    className="btn-tiny"
                    style={{ color: "var(--ok, #a6e3a1)", borderColor: "rgba(166,227,161,.35)" }}
                    onClick={onPost}
                    disabled={posting}
                  >
                    {posting ? "⏳ Posting…" : "📤 Post to ERP"}
                  </button>
                )}
              </div>
            </div>
          );
        }

export default function InvoiceGrid({ rows, onDeleted, onUpdated, limit, grouped = true }) {
  const { hasPermission } = useAuth();
  const [search,    setSearch]    = useState("");
  const [selected,  setSelected]  = useState(new Set());
  const [detailRow, setDetailRow] = useState(null);
  const [editRow,   setEditRow]   = useState(null);
  const [sortKey,   setSortKey]   = useState("created_at");
  const [sortDir,   setSortDir]   = useState("desc");
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [confirmDelete, setConfirmDelete] = useState(null); 
  const canEdit   = hasPermission("edit_invoice");
  const canDelete = hasPermission("delete_invoice");
  const canExport = hasPermission("export_csv");
  const [postingIds, setPostingIds] = useState(new Set());

  const handlePostToErp = async (row) => {
    if (postingIds.has(row.id)) return;
    setPostingIds(prev => new Set(prev).add(row.id));
    try {
      const res = await postInvoiceToErp(row.id);
      if (res.posted_to_erp) {
        toast.success("Posted to ERP successfully");
      } else if (res.already_in_erp) {
        toast.error("This invoice was already sent to ERP earlier");
      } else {
        toast.error(res.error || "ERP push failed");
      }
      onUpdated && onUpdated({
        id: row.id, erp_posted: res.erp_posted,
        erp_post_status_code: res.erp_post_status_code, erp_post_error: res.erp_post_error,
      });
    } catch (e) {
      toast.error(e.response?.data?.error || "ERP push failed");
    } finally {
      setPostingIds(prev => { const n = new Set(prev); n.delete(row.id); return n; });
    }
  };

  const monthOptions = useMemo(() => {
    const counts = new Map();
    let unknownCount = 0;
    rows.forEach(r => {
      const key = getRowMonthKey(r);
      if (!key) { unknownCount++; return; }
      counts.set(key, (counts.get(key) || 0) + 1);
    });
    const opts = [...counts.entries()]
      .sort((a, b) => b[0].localeCompare(a[0]))
      .map(([key, count]) => ({ key, label: monthKeyLabel(key), count }));
    if (unknownCount) opts.push({ key: "unknown", label: "No Date", count: unknownCount });
    return opts;
  }, [rows]);

  const monthFiltered = useMemo(() => {
    if (selectedMonth === "all") return rows;
    if (selectedMonth === "unknown") return rows.filter(r => !getRowMonthKey(r));
    return rows.filter(r => getRowMonthKey(r) === selectedMonth);
  }, [rows, selectedMonth]);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return monthFiltered.filter(r => {
      if (!q) return true;
      const headerMatch = Object.entries(r).some(([k, v]) =>
        k !== "items" && String(v ?? "").toLowerCase().includes(q)
      );
      const itemMatch = r.items?.some(item =>
        Object.values(item).some(v => String(v ?? "").toLowerCase().includes(q))
      );
      return headerMatch || itemMatch;
    });
  }, [monthFiltered, search]);

  const sorted = useMemo(() => {
    return [...filtered].sort((a, b) => {
      const av = String(a[sortKey] ?? "");
      const bv = String(b[sortKey] ?? "");
      return sortDir === "asc" ? av.localeCompare(bv) : bv.localeCompare(av);
    });
  }, [filtered, sortKey, sortDir]);

  const visible = useMemo(() => {
    if (!limit) return sorted;
    return sorted.slice(0, limit);
  }, [sorted, limit]);

  const sellerGroups = useMemo(() => {
    if (!grouped) return null;
    const map = new Map();
    for (const row of visible) {
      const key = row.seller_name?.trim() || "Unknown Seller";
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(row);
    }
    return [...map.entries()];
  }, [visible, grouped]);

  const toggleSelect = id =>
    setSelected(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  const toggleAll = e =>
    setSelected(e.target.checked ? new Set(visible.map(r => r.id)) : new Set());

  const toggleSellerGroup = groupRows =>
    setSelected(prev => {
      const ids  = groupRows.map(r => r.id);
      const n    = new Set(prev);
      const allOn = ids.every(id => n.has(id));
      ids.forEach(id => allOn ? n.delete(id) : n.add(id));
      return n;
    });

  const deleteSingle = id => setConfirmDelete({ ids: [id] });

  const deleteSelected = () => {
    if (!selected.size) return;
    setConfirmDelete({ ids: [...selected] });
  };

  const runDelete = async () => {
    if (!confirmDelete) return;
    const { ids } = confirmDelete;
    try {
      await deleteInvoices(ids);
      toast.success(ids.length > 1 ? `${ids.length} record(s) deleted` : "Record deleted");
      onDeleted(ids);
      setSelected(prev => {
        const n = new Set(prev);
        ids.forEach(id => n.delete(id));
        return n;
      });
    } catch {
      toast.error("Delete failed");
    } finally {
      setConfirmDelete(null);
    }
  };

  const handleVendorResolve = async (id, proceed) => {
    try {
      const updated = await resolveVendorMatch(id, proceed);
      toast.success(proceed ? "Marked as proceeded despite mismatch" : "Vendor mismatch — stopped");
      onUpdated && onUpdated(updated);
    } catch {
      toast.error("Could not update vendor verification");
    }
  };

  const renderCard = (row, featured = false) => (
    <InvoiceCard
      key={row.id}
      row={row}
      selected={selected.has(row.id)}
      onToggle={() => toggleSelect(row.id)}
      onView={() => setDetailRow(row)}
      onEdit={() => setEditRow(row)}
      onDelete={() => deleteSingle(row.id)}
      onExport={() => exportSingleInvoice(row)}
      onVendorResolve={handleVendorResolve}
      onPost={() => handlePostToErp(row)}
      posting={postingIds.has(row.id)}
      canEdit={canEdit}
      canDelete={canDelete}
      canExport={canExport}
      featured={featured}
    />
  );

  return (
    <div className="grid-split">
    <div className="grid-wrap">
      {/* Toolbar */}
      <div className="grid-toolbar">
        <input
          className="grid-search"
          placeholder="🔍  Search across all fields & items…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select
          className="month-picker"
          value={selectedMonth}
          onChange={e => setSelectedMonth(e.target.value)}
        >
          <option value="all">📅 All Months</option>
          {monthOptions.map(o => (
            <option key={o.key} value={o.key}>{o.label} ({o.count})</option>
          ))}
        </select>
        <div className="grid-actions">
          <span className="grid-count">
            {limit && sorted.length > limit
              ? `Showing ${visible.length} of ${sorted.length}`
              : `${visible.length} record${visible.length !== 1 ? "s" : ""}`}
          </span>
          {selected.size > 0 && (
            <button className="btn-danger" onClick={deleteSelected}>
              🗑 Delete {selected.size} selected
            </button>
          )}
          {visible.length > 0 && (
            <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "var(--text2)", cursor: "pointer" }}>
              <input
                type="checkbox"
                style={{ accentColor: "var(--accent2)" }}
                checked={selected.size === visible.length && visible.length > 0}
                onChange={toggleAll}
              />
              Select all
            </label>
          )}
        </div>
      </div>

      {visible.length === 0 ? (
        <div className="empty-state">
          <span style={{ fontSize: 40 }}>📄</span>
          <p>
            {search
              ? "No invoices match your search."
              : selectedMonth !== "all"
                ? "No invoices found for this month."
                : "No invoices found. Upload some PDFs to get started."}
          </p>
        </div>
      ) : grouped ? (
        sellerGroups.map(([sellerName, groupRows]) => (
          <div key={sellerName} className="seller-section">
            <div className="seller-header">
              <div className="seller-title">
                <input
                  type="checkbox"
                  style={{ accentColor: "var(--accent2)", width: 15, height: 15, cursor: "pointer" }}
                  checked={groupRows.every(r => selected.has(r.id))}
                  onChange={() => toggleSellerGroup(groupRows)}
                />
                <span className="seller-name-label">🏭 {sellerName}</span>
                <span className="seller-count">{groupRows.length} invoice{groupRows.length !== 1 ? "s" : ""}</span>
              </div>
              {canExport && (
                <button
                  className="btn-seller-export"
                  onClick={() => exportSellerInvoices(sellerName, groupRows)}
                  title={`Export all ${sellerName} invoices as one CSV`}
                >
                  ⬇ Export All CSV
                </button>
              )}
            </div>

            <div className="invoice-cards-grid">
              {groupRows.map(row => renderCard(row))}
            </div>
          </div>
        ))
      ) : (
        <>
          {visible.length > 0 && (
            <div className="invoice-cards-featured">
              {renderCard(visible[0], true)}
            </div>
          )}
          <div className="invoice-cards-grid">
            {visible.slice(1).map(row => renderCard(row))}
          </div>
        </>
      )}
    </div>

    {detailRow && <DetailPanel row={detailRow} onClose={() => setDetailRow(null)} />}

      {editRow && (
        <EditModal
          row={editRow}
          onClose={() => setEditRow(null)}
          onSaved={updated => { onUpdated && onUpdated(updated); setEditRow(null); }}
        />
      )}

      {confirmDelete && (
        <ConfirmModal
          title="Delete record"
          message={
            confirmDelete.ids.length > 1
              ? `Are you sure you want to delete ${confirmDelete.ids.length} records? This cannot be undone.`
              : "Are you sure you want to delete this record? This cannot be undone."
          }
          onConfirm={runDelete}
          onCancel={() => setConfirmDelete(null)}
        />
      )}
    </div>
  );
}